import {useEffect, useRef, useState } from "react";
import Leftside from "../Landing_page/Left_sidebar/Leftside";
import styles from "./profile.module.css";
import axios from "axios";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Snackbar } from "@material-ui/core";
import { SnackbarContent } from "@material-ui/core";
import styled from "styled-components";
// import { MuiAlert } from "@material-ui/core";

// const Alert = forwardRef(function Alert(props, ref) {
//   return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
// });


const Spinner = styled.div`
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 0.3s linear infinite;
  /* padding: 3px; */
  /* border: 1px solid red; */
  padding: 5px;

  margin-left: 25px;
  margin-top: 10px;

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;

export const EditProfile = () => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tagline, setTagline] = useState("");
    const loggedInUser = useSelector(state => state.loggedInUser);
    const profilePicRef = useRef();
    const coverPicRef = useRef();
    const history = useHistory();
    const nameRef = useRef();
    const taglineRef = useRef();
    const url = process.env.REACT_APP_url;

    useEffect(() => {
        document.getElementById('output').style.display = "none";
        document.getElementById('outputcover').style.display = "none";
        nameRef.current.value = loggedInUser.name;
        taglineRef.current.value = loggedInUser.tagline;
    }, [])
    const handlePic = () => {
        setIsLoading(true);
        if (profilePicRef.current.files[0] === undefined) {
            handleCoverPic();
        } else {
            let formData = new FormData();
            formData.append('profile_pic', profilePicRef.current.files[0]);
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.patch(`${url}/users/${loggedInUser.username}/profilepic`, formData, config)
                .then(response => {
                    // console.log(response);
                    handleCoverPic();
                    // history.push(`/users/${loggedInUser.username}`)
                })
                .catch(error => {
                    alert(error);
                });
        }
    }
    const handleCoverPic = () => {
        if (coverPicRef.current.files[0] === undefined) {
            handlePatch();
        } else {
            let formData = new FormData();
            formData.append('cover_pic', coverPicRef.current.files[0]);
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            axios.patch(`${url}/users/${loggedInUser.username}/coverpic`, formData, config)
                .then(response => {
                    // console.log(response);
                    handlePatch();
                    // history.push(`/users/${loggedInUser.username}`)
                })
                .catch(error => {
                    alert(error);
                });
        }
    }
    const handlePatch = () => {
        const config = {
            tagline: taglineRef.current.value,
            name: nameRef.current.value
        }
        axios.patch(`${url}/users/${loggedInUser._id}`, config)
            .then((res) => {
                setOpen(true);
                setTimeout(() => {
                    history.push(`/users/${loggedInUser.username}`)
                }, 2310)
            })
            .catch((err) => {
                alert(err);
            })
            .finally(() => {
                setIsLoading(false);
            })
    }
    var loadFile = function (event) {
        var output = document.getElementById('output');
        output.style.display = "block";
        output.src = URL.createObjectURL(event.target.files[0]);
        output.onload = function() {
            URL.revokeObjectURL(output.src) // free memory
        }
    };
    var loadFileCover = function (event) {
        var output = document.getElementById('outputcover');
        output.style.display = "block";
        output.src = URL.createObjectURL(event.target.files[0]);
        output.onload = function() {
            URL.revokeObjectURL(output.src) // free memory
        }
    };

  const handleClose = () => {
    setOpen(false);
  };
    return (
        <div className={styles.settingsContainer}>
            <Leftside />
            <div style={{minWidth:"230px"}}></div>
            <div className={styles.editCont}>
                <div className={styles.userSettings}>
                    <div className={styles.subUserSettings1}>
                        <p>User Settings</p>
                    </div>
                    <div className={styles.subUserSettings2}>
                        <div className={styles.opts}>
                            <p style={{color:"#1e59fd"}}>PROFILE</p>
                            <p>EMAIL NOTIFICATIONS</p>
                            <p>PUBLICATIONS</p>
                            <p>DEVELOPER</p>
                            <p>ACCOUNT</p>
                        </div>
                    </div>
            </div>
                <div className={styles.editBox}>
                    <div className={styles.editDiv1}>
                        <h3>Basic Info</h3>
                        <div className={styles.fullname}>
                            <p >Full Name</p>
                            <input ref={nameRef} className={styles.editInpBox}/>
                        </div>
                        <div>
                            <p >Profile Tagline</p>
                            <input ref={taglineRef} maxLength="43" style={{marginBottom:"0"}} className={styles.editInpBox}/>
                        </div>
                            <p style={{marginTop:"21px"}} className={styles.picHeading}>Profile Photo</p>
                        <div className={styles.editPicDiv} style={{ display: "flex"}}>
                            {/* <input className={styles.profilePhoto} type="file" /> */}
                            <input accept="image/*" onChange={(event)=> loadFile(event)} hidden className={styles.dpinp} ref={profilePicRef} type="file" id="dp-btn" />
                            <label className={styles.label1} for="dp-btn">Choose File</label>
                            <img className={styles.disps} id="output" alt="disp" />
                        </div>
                        <p className={styles.picHeading}>Cover Image</p>
                        <div className={styles.editPicDiv} style={{ display: "flex"}}>
                            {/* <input className={styles.profilePhoto} type="file" /> */}
                            <input accept="image/*" onChange={(event)=> loadFileCover(event)} hidden className={styles.dpinp} ref={coverPicRef} type="file" id="cover-btn" />
                            <div><label className={styles.label2} for="cover-btn">Choose File</label></div>
                            <div>
                                <img className={styles.dispscover} id="outputcover" alt="cover" />
                            </div>
                        </div>
                        <div style={{display:"flex"}}>
                        <button style={{cursor:"pointer"}} onClick={handlePic} className={styles.uploadBtn}>
                            Save Changes
                            </button>
                        {isLoading && <Spinner />}
                        </div>
                    </div>
                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        open={open}
                        autoHideDuration={2100}
                        onClose={handleClose}
                    ><SnackbarContent style={{
                            backgroundColor: 'green',
                            width: "290px",
                        height: "60px",
                            }}
                            message={<span id="client-snackbar">Profile updated successfully!</span>}
                        />
                        </Snackbar>
                    <div className={styles.editDiv2}>
                        <h3>Social</h3>
                        <div >
                            <p>Twitter</p>
                            <input className={styles.editInpBox}/>
                        </div>
                        <div >
                            <p>Facebook</p>
                            <input className={styles.editInpBox}/>
                        </div>
                        <div >
                            <p>GitHub</p>
                            <input className={styles.editInpBox}/>
                        </div>
                    </div>
            </div>
            </div>
            <div style={{minWidth:"23px"}}></div>
        </div>
    )
}